$(function () {
    if($('#bookingSeatsCount').length === 0)  {
        return;
    }

    const searchParams = new URLSearchParams(window.location.search)
    const nop_c = parseInt(searchParams.get('nop_c'));
    const nop_y = parseInt(searchParams.get('nop_y'));
    const totalChild = nop_c+nop_y;
    
    $(".input-button-plus").click(function () {
        let inputField = $(this).siblings('input[type="number"]');
        let currentValue = parseInt(inputField.val());
        let inputSum = sumInputs();
        
        if(inputSum<totalChild) {
            changeValue(inputField,currentValue,1);
        } else {
            $('.vaildationAlert').css('display','block');
        }
    });

    $(".input-button-minus").click(function () {
        let inputField = $(this).siblings('input[type="number"]');
        let currentValue = parseInt(inputField.val());
        if (currentValue > 0) {
            changeValue(inputField,currentValue,-1);
        }
    });
    $("#bookingSeatsCount").on('change', function(event) {
            if(sumInputs()>totalChild) {
                $('.vaildationAlert').css('display','block');
                $(event.target).val(0);
                let maxRemainingSeats = totalChild-sumInputs();
                $(event.target).val(maxRemainingSeats);
            } else {
                $('.vaildationAlert').css('display','none');
            }
    })
    function changeValue(input ,currentValue, value) {
        input.val(currentValue+value).change();
    }
    function sumInputs() {
        let inputSum = 0;
        $('#bookingSeatsCount').find('input').each(function() {
            inputSum+=parseFloat($(this).val()) || 0;
        })
        return inputSum;
    }
});

